
import React, { useEffect } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { userManager } from "./Auth";

const LoginPage = () => {
  console.log("LoginPage");

  useEffect(() => {
    // ✅ trigger OIDC login redirect
    userManager.signinRedirect({
      state: {
        path: window.location.pathname,
        search: window.location.search
      }
    }).catch((err) => {
      console.error("Login redirect failed", err);
    });
  }, []);

  return (
    <div className="loading">
      <table className="loader">
        <tbody>
          <tr>
            <td>Redirecting to sign in page, please wait...</td>
          </tr>
          <tr>
            <td>
              <CircularProgress />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default LoginPage;
